module.exports = __webpack_public_path__ + "static/media/combat(27).e2c9c388.PNG";